// extracted by mini-css-extract-plugin
export default {"centered":"iU2AwuNq1NooKYiZRg_U"};